import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Carousel } from 'seagull';
import { useLocaleKeys } from '~/i18n';
const STRIP_GAP_PX = 16;
const WIDGET_MIN_WIDTH_PX = 240;
export const MetricsCardStrip = (param)=>{
    let { items, isEditMode, onReorder, onRemove, testId } = param;
    const { t: invoiceMetricsSectionTexts } = useLocaleKeys('components.invoiceMetricsSection');
    const editMode = isEditMode === true;
    const hasMultipleItems = items.length > 1;
    const enableReorder = editMode && hasMultipleItems;
    const carouselItems = useMemo(()=>items.map((item)=>{
            if (!editMode) {
                return {
                    id: item.id,
                    content: item.render({
                        isEditMode: false
                    })
                };
            }
            return {
                id: item.id,
                content: (param)=>{
                    let { isDragActive, dragHandle } = param;
                    return item.render({
                        isEditMode: true,
                        isDragActive,
                        dragHandle: enableReorder ? dragHandle : undefined,
                        onRemove: onRemove ? ()=>onRemove(item.id) : undefined
                    });
                }
            };
        }), [
        items,
        editMode,
        enableReorder,
        onRemove
    ]);
    return /*#__PURE__*/ _jsx(Carousel, {
        testId: testId,
        items: carouselItems,
        itemMinWidth: WIDGET_MIN_WIDTH_PX,
        gap: STRIP_GAP_PX,
        reorderable: enableReorder,
        onReorder: onReorder,
        reorderBiName: "reorder_invoice_metric_card",
        autoScrollToEndOnItemAdd: editMode,
        scrollLeftAriaLabel: invoiceMetricsSectionTexts.scrollLeftAriaLabel(),
        scrollRightAriaLabel: invoiceMetricsSectionTexts.scrollRightAriaLabel(),
        bi: {
            name: 'metrics_strip'
        }
    });
};
